module.exports = __webpack_public_path__ + "img/Flag_of_Turkey.121e8386.svg";